import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import chevron from '@learningblocks/exp-constants/lib/Images/chevronButton.svg';

import style from './style.module.scss';

const TRIGGER_INTERVAL = 200;

export function Button(props) {
  const [isMouseDown, setMouseState] = React.useState(false);
  const [button, setButton] = React.useState(undefined);
  const [counter, setCounter] = React.useState(0);

  React.useEffect(() => {
    if (isMouseDown) {
      setTimeout(() => {
        if (button === 'UP') {
          onButtonUp();
        } else {
          onButtonDown();
        }
        setCounter(counter + 1);
      }, TRIGGER_INTERVAL);
    }
  }, [isMouseDown, counter]);

  let value = parseInt(props.temperature);

  const onButtonUp = () => {
    props.setTemperature(value + 1);
  };

  const onButtonDown = () => {
    props.setTemperature(value - 1);
  };

  const onMouseDownArrowUp = () => {
    setMouseState(true);
    setButton('UP');
  };

  const onMouseUpArrowUp = () => {
    setMouseState(false);
    setButton('UP');
  };

  const onMouseDownArrowDown = () => {
    setMouseState(true);
    setButton('DOWN');
  };

  const onMouseUpArrowDown = () => {
    setMouseState(false);
    setButton('DOWN');
  };

  return (
    <>
      <div
        className={style.heatblockButton_up}
        onClick={onButtonUp}
        onMouseDown={onMouseDownArrowUp}
        onMouseUp={onMouseUpArrowUp}>
        <Image src={chevron} alt='Button-Up' />
      </div>
      <div
        className={style.heatblockButton_down}
        onClick={onButtonDown}
        onMouseDown={onMouseDownArrowDown}
        onMouseUp={onMouseUpArrowDown}>
        <Image src={chevron} alt='Button-Down' />
      </div>
    </>
  );
}

Button.propTypes = {
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * Set temperature is a function to change the set Temperature
   */
  setTemperature: PropTypes.func,
};
